import { ExamMark } from '@/plugins/api'
import alert from '@/plugins/alert'

/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchMarks({ commit }, options) {
      const marks = await ExamMark.fetch({ ...options })
      return marks
    },
    async fetchMark({ commit }, id) {
      const mark = await ExamMark.fetchOne(id)
      return mark
    },
    async updateMark({ commit }, { id, ...data }) {
      const updatedMark = await ExamMark.update(id, { ...data })
      return updatedMark
    },
    async countMarks({ commit }, options) {
      try {
        return await ExamMark.count(options)
      } catch (e) {
        alert.error(e)
      }
    },
  },
}
/* eslint-disable no-unused-vars */
